<template>
    <div v-if="file">
        <img
            :src="inlineURL"
            style="max-width: 800px"
            v-if="file.content_type.indexOf('image/') == 0"
        />

        <iframe
            :src="inlineURL"
            height="600px"
            v-if="file.content_type.indexOf('application/pdf') == 0"
            :width="width"
        ></iframe>

        <!-- TODO Show Icon for Mime Type/Content Type -->
        <!-- TODO show Video -->

        <br />
        <span class="file-info" v-if="file && !hideFileInfo"
            >{{ file.original_filename }} ({{ file.file_size }})</span
        >
        <a
            :href="downloadURL"
            ng-show="file"
            target="_downloadWindow"
            v-if="!disableDownload"
            >Download
            <cloud-download-icon />
        </a>
    </div>
</template>

<script>
import CloudDownloadIcon from "vue-material-design-icons/CloudDownload";

export default {
    name: "OFilePreview",
    components: { CloudDownloadIcon },
    props: {
        file: {
            type: Object,
            default: () => {},
        },
        disableDownload: { type: Boolean, default: false },
        hideFileInfo: { type: Boolean, default: false },
        width: { type: String, default: "800px" },
    },
    computed: {
        inlineURL: function () {
            if (this.file) {
                return (
                    process.env.VUE_APP_ROOT_API +
                    "/filesystem/download/" +
                    this.file.id +
                    "/?download=false"
                );
            } else {
                return "";
            }
        },
        downloadURL: function () {
            if (this.file) {
                return (
                    process.env.VUE_APP_ROOT_API +
                    "/filesystem/download/" +
                    this.file.id +
                    "/?download=true"
                );
            } else {
                return "";
            }
        },
    },
};
</script>

<style scoped></style>
